var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    zoomAndPan: "magnify",
    viewBox: "0 0 37.5 37.499999",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "76780c0504"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.851562 1.851562 L 35.15625 1.851562 L 35.15625 35.15625 L 1.851562 35.15625 Z M 1.851562 1.851562 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#284be5",
    d: "M 26.71875 17.710938 L 13.8125 10.261719 C 13.175781 9.890625 12.375 10.355469 12.375 11.09375 L 12.375 25.996094 C 12.375 26.671875 13.105469 27.09375 13.691406 26.753906 L 26.71875 19.234375 C 27.304688 18.894531 27.304688 18.050781 26.71875 17.710938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#76780c0504)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#284be5",
    d: "M 28.644531 28.644531 C 25.933594 31.351562 22.332031 32.84375 18.503906 32.84375 C 14.671875 32.84375 11.070312 31.351562 8.363281 28.644531 C 5.65625 25.933594 4.164062 22.332031 4.164062 18.503906 C 4.164062 14.671875 5.65625 11.070312 8.363281 8.363281 C 11.070312 5.65625 14.671875 4.164062 18.503906 4.164062 C 22.332031 4.164062 25.933594 5.65625 28.644531 8.363281 C 31.351562 11.070312 32.84375 14.671875 32.84375 18.503906 C 32.84375 22.332031 31.351562 25.933594 28.644531 28.644531 Z M 18.503906 1.851562 C 9.304688 1.851562 1.851562 9.304688 1.851562 18.503906 C 1.851562 27.699219 9.304688 35.15625 18.503906 35.15625 C 27.699219 35.15625 35.15625 27.699219 35.15625 18.503906 C 35.15625 9.304688 27.699219 1.851562 18.503906 1.851562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/C.6d07ee57c0211d36f582dc1d59655582.svg";
export { ForwardRef as ReactComponent };